import { render, staticRenderFns } from "./TimelineClip.vue?vue&type=template&id=2fb434c4&scoped=true&"
import script from "./TimelineClip.vue?vue&type=script&lang=js&"
export * from "./TimelineClip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb434c4",
  null
  
)

export default component.exports